import { render, staticRenderFns } from "./PremiumReminder.vue?vue&type=template&id=7056cfd6"
import script from "./PremiumReminder.vue?vue&type=script&lang=js"
export * from "./PremiumReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports